type StageWithAutomation = {
  id?: string | number | null;
  // Per-stage automation rule from the `ats_job_stages` endpoint
  // (`_ats_job_stage.json.jbuilder` → `json.automation`): the full active
  // rule, or null when the stage has none. `running_count` is the count of
  // active executions for that rule.
  automation?: { running_count?: number } | null;
};

// Derives the lightning-marker data straight from the stages the page
// already loaded (interview plan / `getInterviewPlan`), which carry a
// per-stage `automation` field. Replaces the old per-stage / per-job
// `workflow_rules` fetches — no extra network round-trips.
//
// Returns the Set of stage ids (stringified) that have an active rule, plus
// the summed `running_count` across them (used by the close-job warning).
export const deriveStageAutomation = (
  stages: ReadonlyArray<StageWithAutomation> | undefined | null
): { stageIds: Set<string>; candidateCount: number } => {
  const stageIds = new Set<string>();
  let candidateCount = 0;
  (stages ?? []).forEach((stage) => {
    if (!stage?.automation) return;
    if (stage.id !== null && stage.id !== undefined) {
      stageIds.add(String(stage.id));
    }
    candidateCount += stage.automation.running_count ?? 0;
  });
  return { stageIds, candidateCount };
};
